import { render, staticRenderFns } from "./ManageRingbaApiToken.vue?vue&type=template&id=7dacb99b&scoped=true"
import script from "./ManageRingbaApiToken.vue?vue&type=script&lang=js"
export * from "./ManageRingbaApiToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dacb99b",
  null
  
)

export default component.exports